export const SUPPORTED_SHELLS = ['bash', 'zsh', 'fish', 'auto'];
